var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteRemoveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.28061C0 4.12563 0.125634 4 0.280612 4H2.0051C2.16008 4 2.28571 4.12563 2.28571 4.28061V6.28571C2.28571 7.72584 1.65132 8.77513 0.382529 9.43359C0.204529 9.52597 0 9.39071 0 9.19017V8.45229C0 8.34961 0.0568738 8.25622 0.143637 8.20129C0.723467 7.83422 1.04569 7.28916 1.1103 6.56612C1.12409 6.41176 0.996814 6.28571 0.841837 6.28571H0.280612C0.125634 6.28571 0 6.16008 0 6.0051V4.28061ZM3.71429 4.28061C3.71429 4.12563 3.83992 4 3.9949 4H5.71939C5.87437 4 6 4.12563 6 4.28061V6.28571C6 7.72584 5.3656 8.77513 4.09682 9.43359C3.91881 9.52597 3.71429 9.39071 3.71429 9.19017V8.45229C3.71429 8.34961 3.77116 8.25622 3.85792 8.20129C4.43775 7.83422 4.75997 7.28916 4.82458 6.56612C4.83837 6.41176 4.7111 6.28571 4.55612 6.28571H3.9949C3.83992 6.28571 3.71429 6.16008 3.71429 6.0051V4.28061Z",
    fill: "current"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1,
    width: 4,
    height: 1,
    rx: 0.3,
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteRemoveIcon);
export default __webpack_public_path__ + "static/media/QuoteRemoveIcon.6a048e80f18015890e36b11ae033f2fb.svg";
export { ForwardRef as ReactComponent };